import React from 'react';
import styled from 'styled-components';
import { formatPrice } from '../utils/priceFormatter';

const Card = styled.div`
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  height: 250px;
  overflow: hidden;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
  
  ${Card}:hover & {
    transform: scale(1.05);
  }
`;

const ArtworkInfo = styled.div`
  padding: 1rem;
`;

const ArtistName = styled.div`
  font-size: 0.9rem;
  margin-bottom: 0.25rem;
  font-weight: 500;
`;

const Title = styled.div`
  font-size: 1rem;
  margin-bottom: 0.5rem;
  color: #333;
`;

const Price = styled.div`
  font-size: 1rem;
  font-weight: 600;
`;

const ArtListing = ({ artwork, onClick }) => {
  return (
    <Card onClick={onClick}>
      <ImageContainer>
        <Image 
          src={artwork.imageThumbnail || artwork.imageMedium || artwork.imageOriginal} 
          alt={artwork.title} 
        />
      </ImageContainer>
      <ArtworkInfo>
        <ArtistName>
          {artwork.artistData?.displayName || 'Unknown Artist'}
        </ArtistName>
        <Title>
          {artwork.title || 'Untitled'}, {artwork.createdYear || ''}
        </Title>
        <Price>
          {artwork.isForSale === false ? 'SOLD' : formatPrice(artwork.price)}
        </Price>
      </ArtworkInfo>
    </Card>
  );
};

export default ArtListing;